import {Navbar} from "react-bootstrap";
import {FormattedMessage} from "react-intl";
import {LinkContainer} from "react-router-bootstrap";
import Logo from "../../components/logo";
import SessionPanel from "../../session-panel";
import React, {HTMLAttributes} from "react";
import {Authentication} from "../../../model/Authentication";

import "./app-header.scss";
import SessionExpirationWatcher from "../../session-expiration-watcher/session-expiration-watcher-redux";

export interface AppHeaderDOMProps
    extends Omit<HTMLAttributes<HTMLDivElement>, "children"> {
  disabled?: boolean;
}

export interface AppHeaderProps extends
    AppHeaderDOMProps {
  auth?: Authentication,
  // Header element reference for accessing header height in container
  headerRef?: (node: HTMLElement) => void,
  // The light|dark variant that Bootstrap requires to be controlled via html attribute
  variant: "light"|"dark"|string,
  bodyVariant: "light"|"dark"|string,
  // trigger for handling eg. 2nd browser window logout messages etc.
  externalLogout?: boolean;
  isSticky?: boolean;

}
export default function AppHeader(props: AppHeaderProps) {
  const {
    auth,
    disabled,
    headerRef,
    variant,
    externalLogout,
    bodyVariant,
    isSticky,
    ...other
  } = props


  return (
    <header
        data-bs-theme={variant}
        ref={headerRef}
        data-test-header
        id=""
        {...other}
        className={"App-Header " + (disabled ? "disabled " : "") + (isSticky ? "stuck " : "")}
    >
        <Navbar expand={false} collapseOnSelect={true}>
          <div className={"navbar-content-container navbar-expand"}>
            <LinkContainer to="/">
              <Navbar.Brand data-test-logo>
                <Logo />
                <span className={"service-name"}>
                  <FormattedMessage
                      defaultMessage="My licenses"
                      description="Name of this admin tool in the header, displayed next to logo"
                  />
                </span>
              </Navbar.Brand>
            </LinkContainer>
            <div className={"user-dropdown"}>
              <SessionPanel auth={auth} />
              <SessionExpirationWatcher externalLogout={externalLogout}
                                        data-bs-theme={bodyVariant} />
            </div>
          </div>
        </Navbar>

    </header>
  );
}
